import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/Logo-Little-stars-1-.png';
import './Navbar.css';

const navLinks = [
  { label: 'Forside',     to: '/' },
  { label: 'Priser',      to: '/priser' },
  { label: 'Faciliteter', to: '/faciliteter' },
  { label: 'Events',      to: '/events' },
  { label: 'Om os',       to: '/om-os' },
];

export default function Navbar() {
  const [scrolled, setScrolled]   = useState(false);
  const [menuOpen, setMenuOpen]   = useState(false);
  const location = useLocation();

  // Is the page one with a dark hero (home)?
  const isHero = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  // On hero pages: start transparent (white text), become white bg on scroll
  const transparent = isHero && !scrolled;

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}${transparent ? ' transparent' : ''}${menuOpen ? ' open' : ''}`}>
      <div className="navbar-inner">

        <Link to="/" className="navbar-logo">
          <img src={logo} alt="Little-Stars logo" className="nav-logo-img" />
        </Link>

        <ul className="navbar-links">
          {navLinks.map(link => (
            <li key={link.to}>
              <Link
                to={link.to}
                className={`nav-link${location.pathname === link.to ? ' active' : ''}`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="navbar-cta">
          <Link to="/login" className="btn btn-login">Log ind</Link>
          <Link to="/bliv-medlem" className="btn btn-primary">Bliv medlem</Link>
        </div>

        <button
          className="hamburger"
          onClick={() => setMenuOpen(v => !v)}
          aria-label={menuOpen ? 'Luk menu' : 'Åbn menu'}
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
          type="button"
        >
          <span /><span /><span />
        </button>
      </div>

      <div
        className={`mobile-menu-backdrop${menuOpen ? ' active' : ''}`}
        onClick={() => setMenuOpen(false)}
        aria-hidden="true"
      />

      <div id="mobile-menu" className={`mobile-menu${menuOpen ? ' active' : ''}`}>
        {navLinks.map(link => (
          <Link
            key={link.to}
            to={link.to}
            className={`mobile-link${location.pathname === link.to ? ' active' : ''}`}
          >
            {link.label}
          </Link>
        ))}
        <div className="mobile-cta">
          <Link to="/login"       className="btn btn-login">Log ind</Link>
          <Link to="/bliv-medlem" className="btn btn-primary">Bliv medlem</Link>
        </div>
      </div>
    </nav>
  );
}
